import React from 'react';
import {withTranslation} from "react-i18next";
import {NextButton} from "../../../booking/ui/shared/components/Buttons";
import {useDispatch} from "react-redux";
import { showSignInModal } from '../data/account/actions/signInModal';

const SignInButton = ({  t, ...props }) => {
    const dispatch = useDispatch();
    return <NextButton {...props}
        onClick={()=>dispatch(showSignInModal(window.location.href))}
        className="btn-primary btn-block btn-lg btn-warning"
    >{t('account.connect_to_continue')}</NextButton>
}

export default withTranslation()(SignInButton);
